import React from "react";

// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const CallNotesHeader = () => {
  const headCells = [
    { id: "Order ID", numeric: false, label: "Order ID" },
    { id: "Note", numeric: false, label: "Note" },
    { id: "Disposition", numeric: false, label: "Disposition" },
    { id: "Agent", numeric: false, label: "Agent" },
    { id: "Date / Time", numeric: false, label: "Date / Time" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {headCell.label}
          </TableCell>
        ))}
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default CallNotesHeader;
